'use strict';

intellidealerAppCoreModule.filter('mergeArray', function () {
  return function(baseArray, subArray, index) {
    if (subArray && subArray.length > 0) {
      return baseArray.slice(0, index+1).concat(subArray).concat(baseArray.slice(index+1));
    }
    return baseArray;
  };
});